//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VerticalBarsChart from "@/components/Charts/VerticalBarsChart.vue";
import Treemap from "@/components/Charts/Treemap.vue";
import HorizontalBarsChart from "@/components/Charts/HorizontalBarsChart.vue";
import BackendServices from "@/services/backend-services.js";
import moment from "moment";
import Table from "@/components/FilterTable/Table.vue";
import * as d3 from "d3";
import d3Locale from "d3-format/locale/en-US.json";
import { EventBus } from "@/event-bus.js";
import ExportGraph from "@/services/export-graph.js";
import ViewGraphTable from "@/pages/FlashReport/components/GraphTable.vue";
import TreemapTable from "@/pages/FlashReport/components/TreemapTable.vue";
import SalesByStoreTable from "@/pages/SalesDashboard/components/SalesByStoreTable.vue";
import AbcCurveTable from "@/pages/SalesDashboard/components/AbcCurveTable.vue";

export default {
  name: "SalesTab",
  props: [
    "selectedRetailer",
    "retailerList",
    "fields",
    "fieldId",
    "startDate",
    "endDate",
    "productHierarchyElementId",
    "storeHierarchyElementId",
    "geoHierarchyElementId",
    "productIds",
    "storeIds",
    "employeeId",
    "employeeName",
    "showGraph",
  ],
  components: {
    VerticalBarsChart,
    Treemap,
    HorizontalBarsChart,
    Table,
    ViewGraphTable,
    TreemapTable,
    SalesByStoreTable,
    AbcCurveTable
  },
  mounted: async function () {
    // Init d3 format
    d3Locale.thousands = " ";
    d3.formatDefaultLocale(d3Locale);
    let response;
    response = await BackendServices.getProductHierarchyLevels();
    this.hierachyLevels = response.data
      .map((item) => ({ value: item.id, label: item.name }))
      .concat(this.hierachyLevels);

    EventBus.$on("clear-dashboard", this.clearData);
  },
  data: function () {
    return {
      // FIXME
      // Get chart data from service.
      d3,
      moment,
      ExportGraph,
      value: 0,
      date: moment(),
      periodGraphSize: {
        width: 700,
      },
      graphMode: {
        salesEvolution: true,
        treeMap: true,
        salesByStoreGraph: true,
        abcCurve: true
      },
      treemapSize: {
        width: 700,
      },
      insigniaGraph: {
        width: 800,
      },
      treeMapLoading: false,
      verticalGraphExpanded: false,
      storesExpanded: false,
      horizonalGraphExpanded: false,
      treemapGraphExpanded: false,
      abcCurveExpanded: false,
      cardexExpanded: false,
      outOfCardexExpanded: false,
      outOfStockExpanded: false,
      overstockingExpanded: false,
      mainVerticalGraphKey: null,
      secondaryVerticalGraphKey: null,
      mainHorizontalGraphKey: null,
      secondaryHorizontalGraphKey: null,
      horizontalGraphExpanded: false,
      productId: null,
      storeId: null,
      datePeriod: "l7d",
      storeHierarchyLevelElementId: null,
      treemapHierarchyId: null,
      tab: null,
      pagination: {
        rowsPerPage: 5,
        page: 1,
      },
      fieldsList: [],
      totalStores: null,
      storesColumns: [
        {
          name: "ranking",
          label: "Ranking",
          align: "left",
          sortable: false,
          field: (row) => row.ranking,
        },
        {
          name: "store-code",
          label: "Código de Loja",
          align: "left",
          sortable: false,
          field: (row) => row.store.code,
        },
        {
          name: "store-description",
          label: "Descrição de Loja",
          align: "left",
          sortable: false,
          field: (row) => row.store.name,
        },
        {
          name: "route-description",
          label: "Rota",
          align: "left",
          sortable: false,
          field: (row) => row.route.name,
        },
        {
          name: "route_sales",
          label: "% Rota",
          align: "left",
          sortable: false,
          field: (row) => row.kpis.route_percentage,
        },
        {
          name: "retailer_sales",
          label: "% RTL",
          align: "left",
          sortable: false,
          field: (row) => row.kpis.rtl_percentage,
        },
        {
          name: "delta_ytd",
          label: "% Variação CY/PY",
          align: "left",
          sortable: false,
          field: (row) =>
            row.kpis.period_delta != null ? row.kpis.period_delta : "N/A",
        },
      ],
      storesList: [],
      storesPagination: {
        rowsPerPage: 10,
        page: 1,
      },
      totalCardex: null,
      cardexColumns: [
        {
          name: "ean",
          label: "EAN",
          field: (row) => row.product.ean,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name",
          label: "Descrição Produto",
          field: (row) => row.product.name,
          align: "left",
          sortable: false,
        },
        {
          name: "product_code_rtl",
          label: "Código Interno RTL",
          field: (row) => row.product.retailer_info.code,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name_rtl",
          label: "Nome Produto RTL",
          field: (row) => row.product.retailer_info.name,
          align: "left",
          sortable: false,
        },
        {
          name: "store_code",
          label: "Código Loja",
          field: (row) => row.store.code,
          align: "left",
          sortable: false,
        },
        {
          name: "store_name",
          label: "Nome Loja",
          field: (row) => row.store.name,
          align: "left",
          sortable: false,
        },
        {
          name: "cardex_status",
          label: "Estado Cardex",
          field: (row) => row.status,
          align: "left",
          sortable: false,
          icon: {
            conditional: true,
            false: {
              name: "mdi-close-circle-outline",
              label: "Inactivo",
              color: "red-4",
            },
            true: {
              name: "mdi-check-circle-outline",
              label: "Activo",
              color: "green-4",
            },
          },
        },
        {
          name: "transition_date",
          label: "Data Entrada",
          field: (row) => row.transition_date,
          align: "left",
          sortable: false,
        },
      ],
      cardexList: [],
      cardexPagination: {
        rowsPerPage: 10,
        page: 1,
      },
      totalOutCardex: null,
      outCardexColumns: [
        {
          name: "ean",
          label: "EAN",
          field: (row) => row.product.ean,
          align: "left",
          sortable: false,
        },
        {
          name: "product_code",
          label: "Código Produto",
          field: (row) => row.product.code,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name",
          label: "Descrição Produto",
          field: (row) => row.product.name,
          align: "left",
          sortable: false,
        },
        {
          name: "product_code_rtl",
          label: "Código Interno RTL",
          field: (row) => row.product.retailer_info.code,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name_rtl",
          label: "Nome Produto RTL",
          field: (row) => row.product.retailer_info.name,
          align: "left",
          sortable: false,
        },
        {
          name: "store_code",
          label: "Código Loja",
          field: (row) => row.store.code,
          align: "left",
          sortable: false,
        },
        {
          name: "store_name",
          label: "Nome Loja",
          field: (row) => row.store.name,
          align: "left",
          sortable: false,
        },
        {
          name: "cardex_status",
          label: "Estado Cardex",
          field: (row) => row.status,
          align: "left",
          sortable: false,
          icon: {
            conditional: true,
            false: {
              name: "mdi-close-circle-outline",
              label: "Inactivo",
              color: "red-4",
            },
            true: {
              name: "mdi-check-circle-outline",
              label: "Activo",
              color: "green-4",
            },
          },
        },
        {
          name: "transition_date",
          label: "Data Saída",
          field: (row) => row.transition_date,
          align: "left",
          sortable: false,
        },
      ],
      outCardexList: [],
      outCardexPagination: {
        rowsPerPage: 10,
        page: 1,
      },
      totalOutStock: null,
      outStockColumns: [
        {
          name: "store_code",
          label: "Código Loja",
          field: (row) => row.store.code,
          align: "left",
          sortable: false,
        },
        {
          name: "store_name",
          label: "Nome Loja",
          field: (row) => row.store.name,
          align: "left",
          sortable: false,
        },
        {
          name: "ean",
          label: "EAN",
          field: (row) => row.product.ean,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name",
          label: "Descrição Produto",
          field: (row) => row.product.name,
          align: "left",
          sortable: false,
        },
        {
          name: "product_code_rtl",
          label: "Código Interno RTL",
          field: (row) => row.product.retailer_info.code,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name_rtl",
          label: "Nome Produto RTL",
          field: (row) => row.product.retailer_info.name,
          align: "left",
          sortable: false,
        },
        {
          name: "flux",
          label: "Fluxo",
          field: (row) => row.flux,
          align: "left",
          sortable: false,
        },
        {
          name: "cardex_status",
          label: "Estado Cardex",
          field: (row) => row.cardex_status,
          align: "left",
          sortable: false,
          icon: {
            conditional: true,
            false: {
              name: "mdi-close-circle-outline",
              label: "Inactivo",
              color: "red-4",
            },
            true: {
              name: "mdi-check-circle-outline",
              label: "Activo",
              color: "green-4",
            },
          },
        },
        {
          name: "sales",
          label: "Vendas",
          field: (row) => row.sales.qty,
          align: "left",
          sortable: false,
        },
        {
          name: "last_sales_day",
          label: "Último Dia de Vendas",
          field: (row) => row.sales.last_sale_date,
          align: "left",
          sortable: false,
        },
        {
          name: "days_without_sale",
          label: "Número Dias s/ Vendas",
          field: (row) =>
            `${row.sales.days_since_last_sale} ${row.sales.days_since_last_sale > 1 ? "dias" : "dia"
            } sem vender`,
          align: "left",
          sortable: false,
        },
        {
          name: "on_hand_stocks",
          label: "Stocks",
          field: (row) => row.stocks.on_hand_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "in_transit_stocks",
          label: "Stock Trânsito",
          field: (row) => row.stocks.in_transit_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "expect_stocks",
          label: "Stock Esperado",
          field: (row) => row.stocks.expected_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "ordered_stocks",
          label: "Stock Encomendado",
          field: (row) => row.stocks.ordered_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "coverage_days",
          label: "Dias Cobertura (Stock)",
          field: (row) => row.coverage_days,
          align: "left",
          sortable: false,
        },
      ],
      outStockList: [],
      outStockPagination: {
        rowsPerPage: 10,
        page: 1,
      },
      totalOverstocking: null,
      overstockingColumns: [
        {
          name: "store_code",
          label: "Código Loja",
          field: (row) => row.store.code,
          align: "left",
          sortable: false,
        },
        {
          name: "store_name",
          label: "Nome Loja",
          field: (row) => row.store.name,
          align: "left",
          sortable: false,
        },
        {
          name: "ean",
          label: "EAN",
          field: (row) => row.product.ean,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name",
          label: "Descrição Produto",
          field: (row) => row.product.name,
          align: "left",
          sortable: false,
        },
        {
          name: "product_code_rtl",
          label: "Código Interno RTL",
          field: (row) => row.product.retailer_info.code,
          align: "left",
          sortable: false,
        },
        {
          name: "product_name_rtl",
          label: "Nome Produto RTL",
          field: (row) => row.product.retailer_info.name,
          align: "left",
          sortable: false,
        },
        {
          name: "flux",
          label: "Fluxo",
          field: (row) => row.flux,
          align: "left",
          sortable: false,
        },
        {
          name: "cardex_status",
          label: "Estado Cardex",
          field: (row) => row.cardex_status,
          align: "left",
          sortable: false,
          icon: {
            conditional: true,
            false: {
              name: "mdi-close-circle-outline",
              label: "Inactivo",
              color: "red-4",
            },
            true: {
              name: "mdi-check-circle-outline",
              label: "Activo",
              color: "green-4",
            },
          },
        },
        {
          name: "sales",
          label: "Vendas",
          field: (row) => row.sales.qty,
          align: "left",
          sortable: false,
        },
        {
          name: "last_sales_day",
          label: "Último Dia de Vendas",
          field: (row) => row.sales.last_sale_date,
          align: "left",
          sortable: false,
        },
        {
          name: "days_without_sale",
          label: "Número Dias s/ Vendas",
          field: (row) =>
            `${row.sales.days_since_last_sale} ${row.sales.days_since_last_sale > 1 ? "dias" : "dia"
            } sem vender`,
          align: "left",
          sortable: false,
        },
        {
          name: "on_hand_stocks",
          label: "Stocks",
          field: (row) => row.stocks.on_hand_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "in_transit_stocks",
          label: "Stock Trânsito",
          field: (row) => row.stocks.in_transit_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "expect_stocks",
          label: "Stock Esperado",
          field: (row) => row.stocks.expected_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "ordered_stocks",
          label: "Stock Encomendado",
          field: (row) => row.stocks.ordered_stocks,
          align: "left",
          sortable: false,
        },
        {
          name: "coverage_days",
          label: "Dias Cobertura (Stock)",
          field: (row) => row.coverage_days,
          align: "left",
          sortable: false,
        },
      ],
      overstockingList: [],
      overstockingPagination: {
        rowsPerPage: 10,
        page: 1,
      },
      salesStocksComparison: {
        sales: {
          week: null,
          month: null,
          year: null,
        },
        stocks: {
          week: null,
          month: null,
          year: null,
        },
        coverage: {
          week: null,
          month: null,
          year: null,
        },
      },
      salesEvolution: {
        mainData: [],
        secondaryData: [],
        lineData: [],
      },
      salesEvolutionMargin: {
        top: 30,
        right: 40,
        bottom: 30,
        left: 40,
      },
      btnGroupRight: [
        { label: "L7D", value: "l7d" },
        { label: "L30D", value: "l30d" },
        { label: "L365D", value: "l365d" },
      ],
      btnGroupLeft: [
        // { label: "Hoje", value: "today" },
        { label: "WTD", value: "wtd" },
        { label: "MTD", value: "mtd" },
        { label: "YTD", value: "ytd" },
      ],
      hierachyLevels: [{ label: "Produto", value: null }],
      productAggregationData: {
        children: [],
      },
      productAggregationMargin: {
        top: 30,
        right: 40,
        bottom: 30,
        left: 40,
      },
      productAggregationColorRange: [
        "#B53548",
        "#2E9E7E",
        "#006DB3",
        "#DE8033",
        "#E8D638",
      ],
      salesByStore: {
        mainData: [],
        secondaryData: [],
      },
      salesByStoreMargin: {
        top: 30,
        right: 40,
        bottom: 30,
        left: 150,
      },
      abcCurve: {
        mainData: [],
        lineData: [],
      },
      abcCurveMargin: {
        top: 30,
        right: 60,
        bottom: 30,
        left: 60,
      },
      verticalBarsGraph: {
        width: 1400,
      },
      daysWithoutStocks: {
        current: null,
        ppr: null,
        py: null,
      },
      fixedDateMetrics: {
        averageMonthlySale: null,
        mtd: {
          current: null,
          ppr: null,
          py: null,
        },
        ytd: {
          current: null,
          ppr: null,
          py: null,
        },
      },
      abcValue: 100,
      storeValue: 10,
      productHierarchyLevelId: null,
      clickedUp: false,
      selectedTreemap: "",
      treeMapSelectedText: {
        label: "",
        valueLabel: "",
        dataValue: "",
        unitLabel: "",
      },
    };
  },
  computed: {
    selectedMetricName: function () {
      if (this.fields.length > 0) {
        return this.fields.find((i) => i.id === this.fieldId).name_label;
      } else {
        return null;
      }
    },
    selectedMetricUnit: function () {
      if (this.fields.length > 0) {
        return this.fields.find((i) => i.id === this.fieldId).unit_label;
      } else {
        return null;
      }
    },
    selectedMetric: function () {
      if (this.fields.length > 0) {
        return this.fields.find((i) => i.id === this.fieldId).button_label;
      } else {
        return null;
      }
    },
    selectedRetailerName: function () {
      let names = '';
      if (Array.isArray(this.selectedRetailer)) {
        let filtered_retailers = this.retailerList.filter(e => this.selectedRetailer.includes(e.id))
        for (const element of filtered_retailers) {
          names += element.name + ", ";
        }
        return names.substring(0, names.length - 2);
      } else {
        return names;
      }
    },
    salesEvolutionVariation: function () {
      if (this.salesEvolution.secondaryData.length === 0 || this.salesEvolution.mainData.length === 0) {
        return [];
      }
      let a = this.salesEvolution.secondaryData.map((obj, i) =>
        (!this.salesEvolution.mainData[i].value || !obj.value) ?
          [i, null] :
          [i, (obj.value / this.salesEvolution.mainData[i].value - 1) * 100]
      )
      return a.filter(e => e[1] != null);
    },
    abcVariation: function () {
      return this.abcCurve.mainData.map((item, index) => {
        return [index, item.abc_curve];
      });
    },
    storeName: function () {
      let store = this.storesList
        .find((i) => i.store.id === this.storeId);
      return store ? store.name : null;
    },
    dates: function () {
      return `${this.startDate}|${this.endDate}`
    }
  },
  methods: {
    downloadActiveCardex: async function () {
      let response = await BackendServices.kpis.ExportCardexForDate(
        this.endDate,
        true,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productIds,
        this.storeId ? this.storeId : this.storeIds,
        this.employeeId,
        this.selectedRetailer,
        this.cardexPagination.page,
        this.cardexPagination.rowsPerPage,
        true
      )

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadInactiveCardex: async function () {
      let response = await BackendServices.kpis.ExportCardexForDate(
        this.endDate,
        false,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productIds,
        this.storeId ? this.storeId : this.storeIds,
        this.employeeId,
        this.selectedRetailer,
        this.outCardexPagination.page,
        this.outCardexPagination.rowsPerPage,
        true
      )

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadStoreList: async function () {
      let response = await BackendServices.kpis.downloadStoreList(
        this.startDate,
        this.endDate,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productId ? this.productId : this.productIds,
        this.storeIds,
        null,
        this.employeeId,
        this.fieldId,
        this.selectedRetailer,
        this.storesPagination.page,
        this.storesPagination.rowsPerPage,
        true
      )

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadOutStockList: async function () {
      let response = await BackendServices.kpis.downloadOutOfStockProducts(
        this.startDate,
        this.endDate,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productId ? this.productId : this.productIds,
        this.storeId ? this.storeId : this.storeIds,
        this.employeeId,
        this.selectedRetailer,
        this.outStockPagination.page,
        this.outStockPagination.rowsPerPage
      )

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadOverstockingList: async function () {
      let response = await BackendServices.kpis.downloadOverstockingProducts(
        this.startDate,
        this.endDate,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productId ? this.productId : this.productIds,
        this.storeId ? this.storeId : this.storeIds,
        this.employeeId,
        this.selectedRetailer,
        this.outStockPagination.page,
        this.outStockPagination.rowsPerPage
      )

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    clearData: function () {
      this.productId = null;
      this.storeId = null;
      this.treemapHierarchyId = null;
      this.selectedTreemap = "";
      this.$refs.storeRankingTable.clearSelection();
    },
    exportSalesEvolutionTable: function () {
      this.$refs.salesEvolutionGraph.exportData()
    },
    exportTreemapGraphTable: function () {
      this.$refs.treemapGraph.exportData()
    },
    exportSalesByStoreGraphTable: function () {
      this.$refs.salesByStoreGraph.exportData()
    },
    exportAbcCurveTable: function () {
      this.$refs.abcCurveGraph.exportData()
    },
    showTreeMapHierarchy(event) {
      this.treeMapSelectedText = event;
    },
    filterByRow: function (row) {
      if (row === null) {
        this.productId = null;
        this.storeId = null;
      }
      if (row.product && row.product.id) {
        this.productId = row.product.id;
      }
      if (row.store && row.store.id) {
        this.storeId = row.store.id;
      }
      this.updateOutOfStockList();
    },
    updateSelectedRetailer(element) {
      this.storeHierarchyLevelElementId = element;
    },
    changePage(tableName, event) {
      switch (tableName) {
        case "stores":
          this.storesPagination = event.pagination;
          this.updateStoreList();
          break;
        case "cardex":
          this.cardexPagination = event.pagination;
          this.updateActiveCardex();
          break;
        case "outCardex":
          this.outCardexPagination = event.pagination;
          this.updateInactiveCardex();
          break;
        case "outStock":
          this.outStockPagination = event.pagination;
          this.updateOutOfStockList();
          break;
        case "overstocking":
          this.overstockingPagination = event.pagination;
          this.updateOverstockingList();
          break;
      }
    },
    changeEndDate: function (event) {
      this.prevValue = this.value;
      this.value = event;
      let diff = this.prevValue - this.value;
      this.$emit(
        "update-end-date",
        moment(this.endDate).subtract(diff, "days")
      );
      let newStartDate = null;
      switch (this.datePeriod) {
        case "today":
          newStartDate = moment(this.endDate);
          break;
        case "wtd":
          newStartDate = moment(this.endDate).startOf("week");
          break;
        case "mtd":
          newStartDate = moment(this.endDate).startOf("month");
          break;
        case "ytd":
          newStartDate = moment(this.endDate).startOf("year");
          break;
        case "l7d":
          newStartDate = moment(this.endDate).subtract(7, "days");
          break;
        case "l30d":
          newStartDate = moment(this.endDate).subtract(30, "days");
          break;
        case "l365d":
          newStartDate = moment(this.endDate).subtract(365, "days");
          break;
      }

      this.$emit("update-start-date", newStartDate);
    },
    drillTreemap(event) {
      if (event.direction === "down") {
        this.clickedUp = false;
        this.treemapHierarchyId = event.data.product_hierarchy_id;
      } else if (event.direction === "up") {
        this.clickedUp = true;
        this.treemapHierarchyId = event.data.parent_id;
      }
    },
    async updateSalesEvolution() {
      if (this.fieldId) {
        this.mainVerticalGraphKey = this.endDate.year() - 1;
        this.secondaryVerticalGraphKey = this.endDate.year();

        this.salesEvolution.mainData = [];
        this.salesEvolution.secondaryData = [];

        let response = await BackendServices.kpis
          .getSalesByMonthForYear(
            this.endDate.year() - 1,
            null,
            null,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.fieldId,
            this.employeeId.length > 0 ? this.employeeId : null,
            this.selectedRetailer
          )
        this.salesEvolution.mainData = response.data.result;

        response = await BackendServices.kpis
          .getSalesByMonthForYear(
            this.endDate.year(),
            null,
            null,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.fieldId,
            this.employeeId.length > 0 ? this.employeeId : null,
            this.selectedRetailer
          )
        this.salesEvolution.secondaryData = response.data.result;
        this.salesEvolution.lineData = this.salesEvolutionVariation;
      }
    },
    async updateSalesByStore() {
      if (this.fieldId) {
        this.mainHorizontalGraphKey = this.endDate.year() - 1;
        this.secondaryHorizontalGraphKey = this.endDate.year();
        BackendServices.kpis
          .getStoreSalesOnPeriod(
            this.startDate,
            this.endDate,
            this.fieldId,
            this.storeValue,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.employeeId,
            this.selectedRetailer
          )
          .then(
            (response) => (this.salesByStore.secondaryData = response.data)
          );
        let prevYearStartDate = moment(this.startDate).subtract(1, "year");
        let prevYearEndDate = moment(this.endDate).subtract(1, "year");
        BackendServices.kpis
          .getStoreSalesOnPeriod(
            prevYearStartDate,
            prevYearEndDate,
            this.fieldId,
            this.storeValue,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.employeeId,
            this.selectedRetailer
          )
          .then((response) => (this.salesByStore.mainData = response.data));
      }
    },
    async updateAbcCurve() {
      if (this.fieldId) {
        let result = {
          mainData: [],
          lineData: [],
        };
        let response = null;
        if (!this.productHierarchyLevelId) {
          response = await BackendServices.kpis.getProductAbcCurve(
            this.startDate,
            this.endDate,
            this.fieldId,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.employeeId,
            this.abcValue,
            this.selectedRetailer
          );
        } else {
          response = await BackendServices.kpis.getHierarchyLevelAbcCurve(
            this.startDate,
            this.endDate,
            this.fieldId,
            this.productHierarchyLevelId,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.employeeId,
            this.abcValue,
            this.selectedRetailer
          );
        }
        result.mainData = response.data;
        this.abcCurve = result;
        this.abcCurve.lineData = this.abcVariation;
      }
    },

    async updateFixedDateMetrics() {
      if (this.fieldId) {
        let response = null;

        BackendServices.kpis
          .getAverageMonthlySales(
            moment(),
            this.fieldId,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeId ? this.storeId : this.storeIds,
            this.employeeId,
            this.selectedRetailer
          )
          .then(
            (response) =>
              (this.fixedDateMetrics.averageMonthlySale = response.data.value)
          );
        // MTD
        response = await BackendServices.kpis.getMonthToDate(
          moment(),
          this.fieldId,
          this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.employeeId,
          this.selectedRetailer
        );
        this.fixedDateMetrics.mtd = response.data;

        response = await BackendServices.kpis.getYearToDate(
          moment(),
          this.fieldId,
          this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.employeeId,
          this.selectedRetailer
        );
        this.fixedDateMetrics.ytd = response.data;
      }
    },
    async updateProductHierarchyAggregation() {
      this.treeMapLoading = true;
      let response = null;
      if (this.fieldId) {
        response =
          await BackendServices.kpis.getChildrenAggregationByHierarchyElement(
            this.startDate,
            this.endDate,
            this.fieldId,
            this.treemapHierarchyId,
            this.productHierarchyElementId,
            this.hGraphHierarchyId
              ? this.hGraphHierarchyId
              : this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productIds,
            this.storeIds,
            this.employeeId,
            this.selectedRetailer
          );

        if (response.data.length > 0) {
          this.showTreeMap = true;
        } else {
          this.showTreeMap = false;
        }
        this.productAggregationData.children = response.data.filter(
          (item) => item.value
        );
      }
      this.treeMapLoading = false;
    },

    async updateSalesStocksComparison() {
      BackendServices.kpis
        .getSalesStocksComparison(
          this.endDate,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productId ? this.productId : this.productIds,
          this.storeId ? this.storeId : this.storeIds,
          this.employeeId,
          this.selectedRetailer
        )
        .then((response) => (this.salesStocksComparison = response.data));
    },

    async updateOutOfStockList() {
      // BackendServices.kpis
      //   .getOutOfStockProducts(
      //     this.startDate,
      //     this.endDate,
      //     this.treemapHierarchyId
      //       ? this.treemapHierarchyId
      //       : this.productHierarchyElementId,
      //     this.storeHierarchyElementId,
      //     this.geoHierarchyElementId,
      //     this.productId ? this.productId : this.productIds,
      //     this.storeId ? this.storeId : this.storeIds,
      //     this.employeeId,
      //     this.selectedRetailer,
      //     this.outStockPagination.page,
      //     this.outStockPagination.rowsPerPage
      //   )
      //   .then((response) => {
      //     this.totalOutStock = response.headers["x-total-count"];
      //     this.outStockList = response.data;
      //   });
    },
    async updateOverstockingList() {
      // BackendServices.kpis
      //   .getOverstockingProducts(
      //     this.startDate,
      //     this.endDate,
      //     this.treemapHierarchyId
      //       ? this.treemapHierarchyId
      //       : this.productHierarchyElementId,
      //     this.storeHierarchyElementId,
      //     this.geoHierarchyElementId,
      //     this.productId ? this.productId : this.productIds,
      //     this.storeId ? this.storeId : this.storeIds,
      //     this.employeeId,
      //     this.selectedRetailer,
      //     this.outStockPagination.page,
      //     this.outStockPagination.rowsPerPage
      //   )
      //   .then((response) => {
      //     this.totalOverstocking = response.headers["x-total-count"];
      //     this.overstockingList = response.data;
      //   });
    },
    async updateActiveCardex() {
      BackendServices.kpis
        .getCardexForDate(
          this.endDate,
          true,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeId ? this.storeId : this.storeIds,
          this.employeeId,
          this.selectedRetailer,
          this.cardexPagination.page,
          this.cardexPagination.rowsPerPage
        )
        .then((response) => {
          this.totalCardex = response.headers["x-total-count"];
          this.cardexList = response.data;
        });
    },
    async updateInactiveCardex() {
      BackendServices.kpis
        .getCardexForDate(
          this.endDate,
          false,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeId ? this.storeId : this.storeIds,
          this.employeeId,
          this.selectedRetailer,
          this.outCardexPagination.page,
          this.outCardexPagination.rowsPerPage
        )
        .then((response) => {
          this.totalOutCardex = response.headers["x-total-count"];
          this.outCardexList = response.data;
        });
    },
    async updateStoreList() {
      if (this.fieldId) {
        BackendServices.kpis
          .getStoreList(
            this.startDate,
            this.endDate,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productId ? this.productId : this.productIds,
            this.storeIds,
            null,
            this.employeeId,
            this.fieldId,
            this.selectedRetailer,
            this.storesPagination.page,
            this.storesPagination.rowsPerPage
          )
          .then((response) => {
            this.totalStores = response.headers["x-total-count"];
            this.storesList = response.data;
          });
      }
    },
  },
  watch: {
    fieldId: {
      // immediate: true,
      handler: function () {
        this.updateSalesByStore();
        this.updateSalesEvolution();
        this.updateAbcCurve();

        this.updateFixedDateMetrics();
        this.updateProductHierarchyAggregation();
        this.updateStoreList();
      },
    },
    abcValue: {
      // immediate: true,
      handler: function () {
        this.updateAbcCurve();
      },
    },
    productId: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateActiveCardex();
        this.updateInactiveCardex();
      },
    },
    storeId: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    selectedRetailer: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    productHierarchyElementId: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    storeIds: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    productIds: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    treemapHierarchyId: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();

        if (this.productAggregationData.children.length > 0) {
          if (this.clickedUp === true) {
            let chain = this.selectedTreemap.split(">");
            chain = chain.slice(0, chain.length - 1);
            this.selectedTreemap = chain.join(">")
          } else {
            let treemap = this.productAggregationData.children.find((i) => i.product_hierarchy_id === this.treemapHierarchyId);
            if (this.selectedTreemap.length === 0) {
              this.selectedTreemap += treemap ? treemap.label : "";
            } else {
              this.selectedTreemap += treemap ? ">" + treemap.label : "";
            }
          }
        }
      },
    },
    storeHierarchyElementId: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    geoHierarchyElementId: {
      // immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateSalesByStore();
        this.updateProductHierarchyAggregation();
        this.updateAbcCurve();

        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateStoreList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateOutOfStockList();
        this.updateOverstockingList();
      },
    },
    "$store.getters.getDateRange": {
      deep: true,
      handler: function () {
        this.datePeriod = null;
      },
    },
    dates: {
      // immediate: true,
      handler: function () {
        this.updateSalesByStore();
        this.updateAbcCurve();

        this.updateProductHierarchyAggregation();
        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateOutOfStockList();
        this.updateOverstockingList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateStoreList();
      },
    },
    // endDate: {
    //   // immediate: true,
    //   handler: function () {
    //     this.updateSalesByStore();
    //     this.updateAbcCurve();

    //     this.updateProductHierarchyAggregation();
    //     this.updateSalesStocksComparison();
    //     this.updateFixedDateMetrics();
    //     this.updateOutOfStockList();
    //     this.updateOverstockingList();
    //     this.updateActiveCardex();
    //     this.updateInactiveCardex();
    //     this.updateStoreList();
    //   },
    // },
    storeValue: {
      // immediate: true,
      handler: function () {
        this.updateSalesByStore();
      },
    },
    productHierarchyLevelId: {
      // immediate: true,
      handler: function () {
        this.updateAbcCurve();
      },
    },
    datePeriod: {
      immediate: true,
      handler: async function () {
        let newStartDate = null;
        switch (this.datePeriod) {
          case "today":
            newStartDate = moment(this.endDate);
            break;
          case "wtd":
            newStartDate = moment(this.endDate).startOf("week");
            break;
          case "mtd":
            newStartDate = moment(this.endDate).startOf("month");
            break;
          case "ytd":
            newStartDate = moment(this.endDate).startOf("year");
            break;
          case "l7d":
            newStartDate = moment(this.endDate).subtract(6, "days");
            break;
          case "l30d":
            newStartDate = moment(this.endDate).subtract(29, "days");
            break;
          case "l365d":
            newStartDate = moment(this.endDate).subtract(364, "days");
            break;
          case null:
            newStartDate = moment(this.startDate)
            break;
        }

        this.$emit("update-start-date", newStartDate);
      },
    },
    employeeId: {
      // immediate: true,
      handler: function () {
        this.storeId = null;
        this.productId = null;
        this.updateSalesByStore();
        this.updateAbcCurve();

        this.updateProductHierarchyAggregation();
        this.updateSalesStocksComparison();
        this.updateFixedDateMetrics();
        this.updateOutOfStockList();
        this.updateOverstockingList();
        this.updateActiveCardex();
        this.updateInactiveCardex();
        this.updateStoreList();
        this.updateSalesEvolution();
      },
    },
  },
};
